var _style, _path, _polyline, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FF6B37;stroke-width:1.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FF6B37;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.1,5h10.4C15.8,5,16,5.2,16,5.5v7c0,0.3-0.2,0.5-0.5,0.5H9l-5,3L4.1,6C4.1,5.4,4.6,5,5.1,5z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "20,20 15,17 8,17 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,9h1c0.6,0,1,0.4,1,1v10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendResponse);
export default __webpack_public_path__ + "static/media/send-response.a32ddafef7b288262dedb3b5a367a564.svg";
export { ForwardRef as ReactComponent };